import {
  CLEAR,
  UPDATE_SELECT_PRODUCT,
  UPDATE_SEARCH_VALUE,
  CLEAR_PRODUCT_LIST,
  CHANGE_CURRENT_PAGE,
  CHANGE_PAGE_SIZE,
  CHANGE_SEARCH_VALUE,
  CHANGE_SELECT_PRODUCT,
  UPDATE_PAGE_SIZE,
  UPDATE_COUNT_SIZE,
  UPDATE_CURRENT_PAGE,
  UPDATE_PRODUCT_LIST,
  CHANGE_EDIT,
  UPDATE_EDIT,
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_START,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_ERROR,
  POST_PRODUCT,
  POST_PRODUCT_START,
  POST_PRODUCT_SUCCESS,
  POST_PRODUCT_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const clear = () => ({ type: CLEAR })
const clearProductList = () => ({ type: CLEAR_PRODUCT_LIST })
const changeSearchValue = (value) => ({ type: CHANGE_SEARCH_VALUE, value })
const changePageSize = (size) => ({ type: CHANGE_PAGE_SIZE, size })
const changeSelectProduct = (id) => ({ type: CHANGE_SELECT_PRODUCT, id })
const updateSelectProduct = (id) => ({ type: UPDATE_SELECT_PRODUCT, id })
const updateSearchValue = (value) => ({ type: UPDATE_SEARCH_VALUE, value })
const updateProductList = (products) => ({ type: UPDATE_PRODUCT_LIST, products })
const updatePageSize = (size) => ({ type: UPDATE_PAGE_SIZE, size })
const updateCountSize = (count) => ({ type: UPDATE_COUNT_SIZE, count })
const updateCurrentPage = (page) => ({ type: UPDATE_CURRENT_PAGE, page })
const changeEdit = (enable) => ({ type: CHANGE_EDIT, enable })
const updateEdit = (enable) => ({ type: UPDATE_EDIT, enable })
const incrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: 1 })
const decrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: -1 })

/* Async Calls */
const fetchProducts = () => ({ type: FETCH_PRODUCTS })
const fetchProductsStart = () => ({ type: FETCH_PRODUCTS_START })
const fetchProductsSuccess = () => ({ type: FETCH_PRODUCTS_SUCCESS })
const fetchProductsError = (error) => ({ type: FETCH_PRODUCTS_ERROR, error })
const startFetchProductsAsync = buildAsyncAction(
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_START,
  [FETCH_PRODUCTS_SUCCESS, FETCH_PRODUCTS_ERROR]
)

const postProduct = (value) => ({ type: POST_PRODUCT, value })
const postProductStart = () => ({ type: POST_PRODUCT_START })
const postProductSuccess = () => ({ type: POST_PRODUCT_SUCCESS })
const postProductError = (error) => ({ type: POST_PRODUCT_ERROR, error })
const startPostProductAsync = buildAsyncAction(
  POST_PRODUCT,
  POST_PRODUCT_START,
  [POST_PRODUCT_SUCCESS, POST_PRODUCT_ERROR]
)

export {
  clear,
  incrementPage,
  decrementPage,
  changePageSize,
  changeSearchValue,
  changeSelectProduct,
  changeEdit,
  updateEdit,
  updateSelectProduct,
  updatePageSize,
  updateCountSize,
  updateCurrentPage,
  updateProductList,
  updateSearchValue,
  clearProductList,
  fetchProducts,
  fetchProductsStart,
  fetchProductsSuccess,
  fetchProductsError,
  startFetchProductsAsync,
  postProduct,
  postProductStart,
  postProductSuccess,
  postProductError,
  startPostProductAsync,
}
